export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.registration-report.index`,
        path: `/${prefix}/${pre}/registration-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.registration-report.index`,
                PageDescription: "Patient Reports: Registration report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.registration-report.index`,
        path: `/${prefix}/${pre}/registration-report/print`,
        component: () => import('./prints/RegistrationReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.registration-report.index`,
                PageDescription: "Patient Reports: Registration report",
            },
            print: true,
        },
    },
];